import { render, staticRenderFns } from "./VirtualUserModal.vue?vue&type=template&id=4b710926&scoped=true&"
import script from "./VirtualUserModal.vue?vue&type=script&lang=js&"
export * from "./VirtualUserModal.vue?vue&type=script&lang=js&"
import style0 from "./VirtualUserModal.vue?vue&type=style&index=0&id=4b710926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b710926",
  null
  
)

export default component.exports